import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosVisible, setIosVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("lp_install_dismissed");
    if (dismissed) return;

    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    // iOS doesn't fire beforeinstallprompt — show manual hint
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    if (isIos) setIosVisible(true);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") {
      setVisible(false);
      localStorage.setItem("lp_install_dismissed", "1");
    }
  };

  const dismiss = () => {
    setVisible(false); setIosVisible(false);
    localStorage.setItem("lp_install_dismissed", "1");
  };

  if (!visible && !iosVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 bg-[#111827] text-white border-2 border-[#002FA7] p-4 shadow-lg" data-testid="install-prompt">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-[#002FA7] flex items-center justify-center font-heading font-black text-lg shrink-0">L/P</div>
        <div className="flex-1 min-w-0">
          <div className="font-bold text-sm mb-1">Install LeadPilot</div>
          {visible && deferred && (
            <p className="text-xs text-[#9CA3AF] mb-3">Add to your home screen for offline access and a faster, app-like experience.</p>
          )}
          {iosVisible && !visible && (
            <p className="text-xs text-[#9CA3AF] mb-3">Tap <b>Share</b> → <b>Add to Home Screen</b> to install LeadPilot.</p>
          )}
          <div className="flex gap-2">
            {visible && deferred && (
              <button onClick={install} data-testid="install-now-btn"
                      className="bg-white text-[#111827] text-xs font-bold px-3 py-1.5 flex items-center gap-1 hover:bg-[#F3F4F6]">
                <DownloadSimple size={12} weight="bold" /> Install
              </button>
            )}
            <button onClick={dismiss} data-testid="install-dismiss-btn"
                    className="text-xs font-bold px-3 py-1.5 border border-[#374151] hover:bg-[#1F2937]">
              Not now
            </button>
          </div>
        </div>
        <button onClick={dismiss} className="p-1 hover:bg-[#1F2937]" data-testid="install-close-btn">
          <X size={14} weight="bold" />
        </button>
      </div>
    </div>
  );
}
